<template>
  <div v-if="visible" class="overlay">
    <div class="backdrop">
      <p class="message">{{ message }}</p>
      <img v-if="helperSrc" class="helper" :src="helperSrc" alt="Image Help" />
      
      <!-- Button inside the modal -->
      <button class="close-button" @click="startGame">{{letsgo_label[language]}}</button>
    </div>
    <img class="character" :src="characterSrc" alt="Professor Pep" />
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      gameName: '', // Initialize as empty
      letsgo_label: {en: "Let's go!", el: "Πάμε!", it: "Andiamo!", ro: "Hai să mergem!", uk: "Поїхали!"},
      language: 'en',
    };
  },
  computed: {
    characterSrc() {
      return require('@/assets/game-characters/professor_pep_talking.gif');
    },
    helperSrc() {
      try {
        return require(`@/assets/game-help/${this.language}_${this.gameName}_help.png`);
      } catch (error) {
        console.warn('Helper image not found for game:', this.gameName);
        return null;
      }
    },
  },
  methods: {
    startGame() {
      this.closeOverlay();  // Close the overlay
      this.$emit('start-game', this.gameName); // Emit event to start the game with the current gameName
    },
    closeOverlay() {
      this.$emit('update:visible', false); // Emit the event to change the visibility
    },
  },
  created(){
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE "+this.language);
  },
  mounted() {
    console.log('Current route path:', this.$route.path);

    // Extract the game name from the route path
    this.gameName = this.$route.path.split('/')[1] || 'default_game';
    console.log('Extracted gameName:', this.gameName);
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease-out;
}

.backdrop {
  position: relative;
  background-color: hwb(0 100% 0% / 0.5);
  color: #333;
  text-align: center;
  font-size: 1.6rem;
  border-radius: 12px;
  /* box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); */
  padding: 20px;
  max-width: 750px;
  width: 80%;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;  /* Ensure elements are spaced vertically */
  animation: slideUp 0.4s ease-out;
}

.message {
  font-family: 'Arial', sans-serif;
  margin-bottom: 0px;
  color: #ffffff;
  font-size: 1.2rem;
}

.character {
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 35%;
  animation: floatIn 1.5s ease-out;
}

.helper {
  margin-top: 10px;
  width: 100%;
  /* max-width: 400px; */
  height: auto;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: block;  /* Ensures it is a block-level element */
  margin-left: auto;  /* Centers the element horizontally */
  margin-right: auto; /* Centers the element horizontally */
}


.close-button {
  position: relative;
  margin-top: 20px;  /* Reduced space between the helper image and the button */
  background-color: #00aaff;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 1.2rem; 
  padding: 10px 20px;  /* Reduced horizontal padding to make it less wide */
  cursor: pointer;
  z-index: 1010;
  transition: all 0.3s ease;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);  /* Adjusted shadow for smaller button */
  max-width: 180px;  /* Limit the width if necessary */
  display: block;  /* Makes the button block-level */
  margin: 20px auto;  /* Center the button horizontally */
  text-align: center;  /* Ensure text is centered */
}




.close-button:hover {
  background-color: #0077cc;
  transform: scale(1.1);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slideUp {
  0% {
    transform: translateY(100px);
  }
  100% {
    transform: translateY(0);
  }
}

.helper {
  margin-top: 10px;
  width: 80%; /* Adjust the width to make it smaller */
  max-width: 300px; /* Reduced maximum width */
  height: auto; /* Ensure the aspect ratio is maintained */
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: block; /* Ensures it is a block-level element */
  margin-left: auto; /* Centers the element horizontally */
  margin-right: auto; /* Centers the element horizontally */
}


@keyframes floatIn {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
